import { ACTION_TYPES } from "lib/Constants";
import { getBuildingInquiryHistory } from "./BuildingActions";

const {
  LOAD_MARKETPLACE_BUILDING_LIST_REQUEST,
  LOAD_MARKETPLACE_BUILDING_LIST_SUCCESS,
  LOAD_MARKETPLACE_BUILDING_LIST_ERROR,
  LOAD_MARKETPLACE_BUILDING_DETAIL_SUCCESS,
  LOAD_MARKETPLACE_BUILDING_DETAIL_ERROR,
  LOAD_MARKETPLACE_BUILDING_DETAIL_REQUEST,
  IS_LIST_TO_DETAIL,
  CLEAR_BUILDING_DETAIL,
} = ACTION_TYPES;

export default {
  LOAD_SUCCESS: LOAD_MARKETPLACE_BUILDING_LIST_SUCCESS,
  LOAD_ERROR: LOAD_MARKETPLACE_BUILDING_LIST_ERROR,
  LOAD_REQUEST: LOAD_MARKETPLACE_BUILDING_LIST_REQUEST,

  LOAD_DETAIL_REQUEST: LOAD_MARKETPLACE_BUILDING_DETAIL_REQUEST,
  LOAD_DETAIL_SUCESS: LOAD_MARKETPLACE_BUILDING_DETAIL_SUCCESS,
  LOAD_DETAIL_ERROR: LOAD_MARKETPLACE_BUILDING_DETAIL_ERROR,

  IS_LIST_TO_DETAIL: IS_LIST_TO_DETAIL,
  CLEAR_BUILDING_DETAIL: CLEAR_BUILDING_DETAIL,
};
